import React from "react";
import cx from 'classnames';
import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import DeleteUserModal from "./DeleteUserModal";
import { openDeleteUserModal } from "../../actions/modalActions";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import arrowIcon from '../../../public/SiteIcons/arrowGreen.svg';

import messages from "../../locale/messages";

import bt from '../../components/commonStyle.css';
import s from './DeleteUserForm.css';

class DeleteUserForm extends React.Component {

    handleClick = () => {
        const { openDeleteUserModal } = this.props;
        openDeleteUserModal();
    }

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <div className={cx('inputFocusColor', 'commonListingBg', 'noMarginBottom','heightAuto')}>
                    <DeleteUserModal />
                    <h1 className={s.listingTitleText}>{formatMessage(messages.deleteAccount)}</h1>
                    <p className={cx(s.deleteMessageContent,'textWhite')}><span className={cx(s.deleteMessageContentLabel,'textWhite')}>{formatMessage(messages.deleteMessageContentLabel)}</span>{' '}<span>
                    {formatMessage(messages.deleteMessageContent)}
                        </span></p>
                    <div className={s.textEnd}>
                        <Button className={cx(s.deleteButton,s.whiteSpaceNormal)} onClick={this.handleClick}>
                            <span>{formatMessage(messages.deleteMessage)}</span>
                            <img src={arrowIcon} alt="arrowIcon" className={cx(s.arrowIcon,'deleteButtonArrowIcon')}/>
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    openDeleteModal: state?.modalStatus?.openDeleteModal,
});

const mapDispatch = {
    openDeleteUserModal
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(DeleteUserForm)));

